export default function within(min, value, max) {
  return Math.max(min, Math.min(value, max));
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@popperjs/core/lib/utils/within.js
// module id = 346
// module chunks = 1